module.exports = require('./lodash.js');


/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/index.js
 ** module id = 208
 ** module chunks = 0
 **/